/* eslint-disable no-unused-vars */
import React from "react";

// eslint-disable-next-line react/prop-types
function Logout({ width = 18, height = 18 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
    >
      <path
        id="logout_FILL0_wght400_GRAD0_opsz24"
        d="M5,21a2,2,0,0,1-2-2V5A2,2,0,0,1,5,3h7V5H5V19h7v2Zm11-4-1.375-1.45L17.175,13H9V11h8.175l-2.55-2.55L16,7l5,5Z"
        transform="translate(-3 -3)"
        fill="#8c8c8c"
      />
    </svg>
  );
}

export default Logout;
